
import { Vue, Component, Prop } from "vue-property-decorator";
import { SimpleRule, RuleField } from "../core/messages";

@Component({})
export default class SimpleRuleComp extends Vue {
  // Props
  @Prop({ required: true, type: Object })
  value!: SimpleRule;

  // Data
  fieldChoices: RuleField[] = ["roonVersion", "roonPlatform", "roonProduct"];

  // Computed

  // Methods
  updateRule(prop: keyof SimpleRule, val: any) {
    this.$emit("input", {
      ...this.value,
      [prop]: val
    });
  }

  // Life-cycle hooks
}
